import React from 'react';
import AboutCompany from '../Assets/AboutCompany.jpg';
import styled from 'styled-components';
import data from '../Assets/data.json';
import 'bootstrap/dist/css/bootstrap.min.css';

const Wrapper = styled.div`
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 3rem 0;
  }

  @media (min-width: 769px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin: 2rem 6%;
  }

  @media (min-width: 1025px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin: 0 21%;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: justify;

  @media (max-width: 768px) {
    padding: 5% 10%;
  }

  @media (min-width: 769px) {
    padding: 0 10%;
  }

  @media (min-width: 1025px) {
    padding: 0 20%;
  }
`;

const Title = styled.h2`
  font-weight: bolder;
  margin-bottom: 1rem;
`;

const CompanySection = () => {
	return (
		<Wrapper>
			<Container>
				<Title>{data.company.title}</Title>
				<span>Prowadzę spotkania coachingowe w&nbsp;oparciu o&nbsp;Twoje indywidualne potrzeby. Nie pracuję według ustalonych schematów. Każde spotkanie jest inne, bo&nbsp;każdy człowiek jest wyjątkowy i&nbsp;jedyny w&nbsp;swoim rodzaju. Podstawą mojej pracy jest nawiązanie relacji przyjaciel-przyjaciel. Moim zadaniem jest bycie z&nbsp;Tobą i&nbsp;wsparcie w&nbsp;Twojej podróży, którą podejmiesz w&nbsp;czasie naszego spotkania, ale to&nbsp;Ty&nbsp;decydujesz w&nbsp;jakim kierunku i&nbsp;w&nbsp;jaki sposób chcesz tę&nbsp;drogę pokonać. Ważnym elementem każdego spotkania jest nazwanie tego z&nbsp;czym masz do&nbsp;czynienia i&nbsp;co&nbsp;chcesz przepracować. Coaching alternatywny, ponieważ w&nbsp;czasie sesji, o&nbsp;ile wyrazisz na&nbsp;to&nbsp;zgodę, stosuję m.in.&nbsp;elementy teatru.</span>
			</Container>
			<img className='d-block w-100 h-100' alt="About company" src={AboutCompany}/>
		</Wrapper>
	);
};

export default CompanySection;
